import styled from 'styled-components';

export const TextCardWrapper = styled.div`
  margin: 12px 0 4px;
  padding-bottom: 10px;
  max-width: 363px;
  cursor: pointer;
  transition: transform 0.5s ease;

  &:hover {
    transform: scale(1.04);
  }
  @media (max-width: 720px) {
    flex-basis: 98%;
    cursor: default;
    max-width: 100%;
  }
`;

export const TextBox = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 1.1em;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  min-height: 128px;
`;

export const TextCardTitle = styled.h4`
  color: #6e6e6e;
  font-size: 9px;
  font-weight: 500;
  margin: 12px 0 0;
`;

export const TextCardBody = styled.p`
  font-size: 16px;
  padding: 6px 0 4px;
  margin-bottom: 6px;
  color: rgb(0 0 0 / 87%);
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const TextCardAnswer = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  & span {
    padding-left: 4px;
    font-size: 12px;
    color: #0000008c;
    font-weight: 500;
  }

  & img {
    width: 16px;
    height: 16px;
  }
`;

export const TextCardActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;
